var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isNotMajorItem)?_c('div',{staticClass:"event"},[_c('p',{class:{ 'no-discount': _vm.isInactiveDiscountItem }},[_c('span',{class:_vm.cartTagDisplay[_vm.item.cartTag]?.style},[_vm._v(" "+_vm._s(_vm.cartTagDisplay[_vm.item.cartTag]?.text)+" ")]),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.item.discountName))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }